export const colorsComparisonHex = [
  '#3874CB',
  '#61B258',
  '#FACB00',
  '#C23F38',
  '#54B9D1',
  '#91218C',
  '#1F3E1A',
  '#1C4E80',
  '#00BFA5',
  '#009FE3',
  '#75140C',
  '#FFA600',
  '#D485B2',
  '#926531',
  '#5C9790',
  '#D7BFFA',
  '#AED581',
  '#7E909A',
  '#0B85AE',
  '#DB6917'
];
